// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"39b9e403","393":"91c295da","507":"1198645d","724":"dad5adf2","847":"2d56416e","928":"f582fc32"}[chunkId] + ".chunk.js";
};